import { render, staticRenderFns } from "./Funding.vue?vue&type=template&id=286c6b40&"
import script from "./Funding.vue?vue&type=script&lang=js&"
export * from "./Funding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports